export default __webpack_public_path__ + "maps-examples-shape-collection-1200-e190399e8678be8d2cfa393501caee59.png";